module.exports = __webpack_public_path__ + "assets/clear_search_old-86c200.svg";